import { createRouter, createWebHistory } from 'vue-router';
let router;
export let hasUpdatedRouter = false;

const routes = [
  {
    path: '/',
    name: 'HOME',
    meta: {},
    component: () => import('@/views/index.vue'),
  },
  {
    path: '/v2',
    redirect: '/',
  },
  {
    path: '/limithome',
    name: 'HOME_LIMIT',
    meta: {},
    component: () => import('@/views/limitIndex.vue'),
  },
  {
    path: '/loginOld',
    name: 'LOGINOLD',
    meta: {},
    component: () => import('@/views/login.vue'),
  },
  {
    path: '/login',
    name: 'LOGIN',
    meta: {},
    component: () => import('@/views/loginV2.vue'),
  },
  {
    path: '/loginV2',
    name: 'LOGINV2',
    meta: {},
    component: () => import('@/views/loginV3.vue'),
  },
  {
    path: '/phoneLogin',
    name: 'PHONE_LOGIN',
    meta: {},
    component: () => import('@/views/phoneLogin.vue'),
  },
  {
    path: '/backendManage',
    meta: {
      allowRole: ['manager', 'isBackendPermissionAllocator'],
    },
    component: () => import('@/views/backendManage/backend.vue'),
  },
  {
    path: '/userManage',
    meta: {
      allowRole: ['manager', 'backendManagerOrDeveloper'],
    },
    component: () => import('@/views/userManage/user.vue'),
  },

  {
    path: '/userAuth',
    meta: {
      allowRole: ['manager', 'backendManagerOrDeveloper', 'isBackendPermissionAllocator'],
    },
    component: () => import('@/views/authManage/userAuth.vue'),
  },
  {
    path: '/pointAuth',
    meta: {
      allowRole: ['manager', 'backendManagerOrDeveloper', 'isBackendPermissionAllocator'],
    },
    component: () => import('@/views/authManage/pointAuth.vue'),
  },

  {
    path: '/visitLog',
    meta: {
      allowRole: ['manager'],
    },
    component: () => import('@/views/log/visit.vue'),
  },
  {
    path: '/loginLog',
    meta: {
      allowRole: ['manager'],
    },
    component: () => import('@/views/log/login.vue'),
  },
  {
    path: '/backendLog',
    meta: {
      allowRole: ['manager'],
    },
    component: () => import('@/views/log/backend.vue'),
  },
  {
    path: '/authLog',
    meta: {
      allowRole: ['manager'],
    },
    component: () => import('@/views/log/authLog.vue'),
  },
  {
    path: '/operationLog',
    meta: {
      allowRole: ['manager'],
    },
    component: () => import('@/views/log/operationLog.vue'),
  },

  {
    path: '/reachMange',
    name: 'REACH_MANAGE',
    meta: {},
    component: () => import('@/views/reachManage/reach.vue'),
  },
];

export const updateRouter = (userInfo) => {
  if (hasUpdatedRouter) {
    return false;
  }
  const isManager = userInfo?.is_manager;
  const isBackendManagerOrDeveloper = userInfo?.is_backend_manage_or_developer;
  const isBackendPermissionAllocator = userInfo?.is_backend_permission_allocator;
  let filterRoutes = [];
  if (isManager) {
    filterRoutes = filterRoutes.concat(routes.filter((i) => i?.meta?.allowRole?.includes('manager')));
  }
  if (isBackendManagerOrDeveloper) {
    filterRoutes = filterRoutes.concat(routes.filter((i) => i?.meta?.allowRole?.includes('backendManagerOrDeveloper')));
  }
  if (isBackendPermissionAllocator) {
    filterRoutes = filterRoutes.concat(
      routes.filter((i) => i?.meta?.allowRole?.includes('isBackendPermissionAllocator'))
    );
  }

  filterRoutes = filterRoutes.concat([
    {
      path: '/404',
      name: 'NotFound',
      meta: {},
      component: () => import('@/views/404/404.vue'),
    },
    {
      path: '/:catchAll(.*)',
      meta: {},
      redirect: '/404',
    },
  ]);

  filterRoutes.forEach((route) => {
    router.addRoute(route);
  });
  hasUpdatedRouter = true;
};
export const newRouter = () => {
  let filterRoutes = routes.filter((i) => !i?.meta?.allowRole);
  router = createRouter({
    history: createWebHistory('/'),
    routes: filterRoutes,
  });
  return router;
};
export { router };
